import { axiosMeedioClient } from './client';
import { dedupeInFlight } from './inFlightDedupe';
import { buildListQueryParams } from './schedulingMeetingsList';
import { MeetingResponse } from './types';

export enum MeetingType {
  Scheduled = 'scheduled',
}

export interface ListScheduledMeetingsParams {
  messengerRoomId?: string;
  messengerRoomIds?: string[];
  workspaceMatrixRoomId?: string;
  status?: 'active' | 'all';
  messengerLinkedOnly?: boolean;
  type?: MeetingType;
}

export const listScheduledMeetings = (params?: ListScheduledMeetingsParams): Promise<MeetingResponse[]> => {
  const queryParams = buildListQueryParams(params);

  // queryParams keys are sorted by buildListQueryParams, so the serialized key
  // is stable for identical requests regardless of input order (AC-B4).
  const key = `meetings:${JSON.stringify(queryParams)}`;

  return dedupeInFlight(key, async () => {
    const { data } = await axiosMeedioClient.get<MeetingResponse[]>('/meetings', {
      params: Object.keys(queryParams).length ? queryParams : undefined,
    });
    return data;
  });
};
